// extracted by mini-css-extract-plugin
export default {"wrapper":"socialShare_wrapper__nR39o","shareButton":"socialShare_shareButton__TSrJ0"};